export default {"src":"/_next/static/media/bg-right-image.d09c988a.svg","height":582,"width":572,"blurWidth":0,"blurHeight":0};